// packages/api-client/src/services/quickstartService.ts
import { getApiClient } from '../client';
import { handleApiError } from '../utils/handleApiError';
import type { QuickstartCreatePayload, QuickstartResponse, ServiceResponse } from '@dopomogai/types';

export const quickstartService = {
  createAgentWidget: (payload: QuickstartCreatePayload): ServiceResponse<QuickstartResponse> => {
    return getApiClient().post<QuickstartResponse>('/quickstart/agent-widget', payload)
      .then(response => response.data)
      .catch(err => handleApiError(err, 'creating agent + widget via quickstart'));
  },

  createAgentWidgetV2: (payload: QuickstartCreatePayload): ServiceResponse<QuickstartResponse> => {
    return getApiClient().post<QuickstartResponse>('/quickstart/agent-widget-v2', payload)
      .then(response => response.data)
      .catch(err => handleApiError(err, 'creating agent + installation widget via quickstart v2'));
  },
};
